<template>
  <div class="card-wrapper">
      <f7-card>
        <f7-card-header
          valign="bottom"
          :class="titleClass"
          :style="titleImageStyle">
           <div
            :class="showGradient"
            class="headerImageCaption">
            <div
              class="card__CaptionText"
              :style="titleStyle">
              {{title}}
            </div>
            <div class="card__headerOption">
              <div class="headerOption__date">
                <a :style="subtitleStyle">{{subtitle}}</a>
              </div>
            </div>
          </div>
        </f7-card-header>
        <f7-card-content
          :inner="false"
          v-if="content != ''"
          :style="contentStyle">
          <div
            class="card-content-inner ql-editor"
            v-html="content">
          </div>
        </f7-card-content>
      </f7-card>
  </div>
</template>
<script>
import { IsNullOrEmpty } from '@/modules/helper/index'
export default {
  props: {
    imageName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    titleFontFace: {
      type: String,
      default: 'inherit'
    },
    subtitle: {
      type: [String, Number],
      default: ''
    },
    subtitleFontFace: {
      type: String,
      default: 'inherit'
    },
    content: {
      type: String,
      default: ''
    },
    contentFontFace: {
      type: String,
      default: 'inherit'
    }
  },
  computed: {
    titleStyle() {
      return {
        'font-family': this.titleFontFace
      }
    },
    titleImageStyle() {
      let self = this
      let elemetStyl = {}
      if (!IsNullOrEmpty(self.imageName)) {
        let url = `url(${this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl}${self.imageName})`
        elemetStyl = {
          'background-image': url
        }
      }
      return elemetStyl
    },
    subtitleStyle() {
      return {
        'font-family': this.subtitleFontFace
      }
    },
    contentStyle() {
      return {
        'font-family': this.contentFontFace
      }
    },
    titleClass() {
      let self = this
      let cObj = {
        'no-border': true,
        'card__headerNoImage': true
      }
      if (!IsNullOrEmpty(self.imageName)) cObj = { 'no-border': true, 'card__headerImage': true, 'card__headerNoImage': false }
      if (IsNullOrEmpty(self.imageName)) cObj = { 'no-border': true, 'card__headerImage': false, 'card__headerNoImage': true }
      return cObj
    },
    showGradient() {
      let self = this
      let cObj = {
        'card__headerImageCaption': true
      }
      if (IsNullOrEmpty(self.imageName)) cObj = { 'card__headerImageCaption': false }
      return cObj
    }
  },
  methods: {
    ImageUrl: function(value) {
      return this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl + value
    }
  }
}
</script>
<style scoped>
  /* .card-wrapper{
    padding: 10px 0px!important;
  } */
  .card-wrapper .card{
    margin: 0px!important;
  }
  .card__headerImage {
    min-height: 50vw;
    padding: 0px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .headerImageCaption {
    width: 100%;
    height: 33%;
  }
  .card__CaptionText {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 10px 15px 0px 15px;
    font-weight: bold;
    font-size: 1.3em;
  }
  .card__headerOption {
    padding: 0px 15px 10px 15px;
    overflow: hidden;
  }
  .card__headerOption .headerOption__date{
    float: left;
    font-size: 1.0em;
  }
  .card__headerOption .headerOption__item{
    float: right;
    font-size: 1.0em;
  }
  .headerOption__item .icon {
    font-size: 0.9em;
  }
  .card__headerNoImage{
    padding:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Card.vue